import ReadOnly from '../../components/ReadOnly.vue'
import * as Vendor from '@/services/rest-api/lib/vendor/vendor'
import VendorStatus from '../../components/VendorStatus.vue'

const field = { 
  name: 'vendor_id',
  showKey: 'vendor.id',
  type: 'vendor-value-help',
  label: 'Nama Vendor',
  placeholder: 'Pilih Nama Vendor',
  trackBy: 'id',
  displayedBy: 'name',
  listGetter: Vendor.getRatesWithFilters(['status.name eq ACTIVE', 'paired_company_id gt 0']),
  headerInfoComponent: ReadOnly,
  headerInfoProps: {
    items: [
      {
        key: 'box_type',
        label: 'Jenis Kendaraan',
        bold: true,
        value: '',
      },
      {
        key: 'origin',
        label: 'Kota Asal',
        bold: true,
        value: '',
      },
      {
        key: 'destination',
        label: 'Kota Tujuan',
        bold: true,
        value: '',
      },
      {
        key: 'total_weight',
        label: 'Total Berat (Kg)',
        bold: true,
        value: '',
      },
    ],
  },
  tableFields: [
    {
      label: 'Nama Vendor',
      key: 'name',
    },
    {
      label: 'Terhubung',
      key: 'status.name',
      name: 'status',
      isSlot: true,
      slotComponent: VendorStatus,
      thStyle: 'text-align:center;',
      tdAttr: {
        style: 'text-align:center;',
      },
    },
    {
      label: 'Nomor Kontrak',
      key: 'contract_number',
    },
    {
      label: 'Tarif',
      key: 'base_price',
      formatter: value => value ? value.toLocaleString() : value,
    },
    {
      label: 'Asal',
      key: 'origin',
    },
    {
      label: 'Tujuan',
      key: 'destination',
    },
    {
      label: 'Jenis Box',
      key: 'box_type',
    },
    {
      label: 'Kapasitas Berat (Kg)',
      key: 'total_weight',
      formatter: value => value ? value.toLocaleString() : value,
    },
    {
      label: 'Kapasitas Volume (Cbm)',
      key: 'total_volume',
      formatter: value => value ? value.toLocaleString() : value,
    },
  ],
}

export default field